import React from 'react';
import Landing from './sections/Landing';
import Information from './sections/Information';
import Program from './sections/Program';
import Staff from './sections/Staff';
import Opinions from './sections/Opinions';
import Brochure from './sections/Brochure';
import Contact from './sections/Contact';
import Container from './styles';

const Home = () => {
	return (
		<Container>
			<Landing />
			<Information />
			<Program />
			<Staff />
			<Opinions />
			<Brochure />
			<Contact />
		</Container>
	);
};

export default Home;
